import { useGetGivenFeedback } from "src/http";
import { useUserFeedbackSettings } from "../hooks";
import { UserFeedbackList } from "./UserFeedbackList";
import { UserFeedbackListSkeleton } from "./UserFeedbackListSkeleton";

interface Props {
  userId: string;
}

const UserFeedbackGivenList = (props: Props) => {
  const { settings, updateSettings } = useUserFeedbackSettings(props.userId);
  const { data, isLoading } = useGetGivenFeedback(props.userId, {
    filters: settings.givenFeedbackFilters,
  });

  if (isLoading || data === undefined) {
    return <UserFeedbackListSkeleton />;
  }

  return (
    <UserFeedbackList
      title="Given"
      items={data}
      groupBy={settings.givenFeedbackGroupByOption}
      filters={settings.givenFeedbackFilters}
      onGroupByChanged={(value) => updateSettings({ givenFeedbackGroupByOption: value })}
      onFilterByChanged={(filters) => updateSettings({ givenFeedbackFilters: filters })}
    />
  );
};

export { UserFeedbackGivenList };
